module.exports = __webpack_public_path__ + "static/media/residential-multi-family.db2b55b3.svg";